import React from "react";
import { useLocation } from "react-router-dom";
import { Header, PersonalCardContract } from "../../components/common";
import './PersonalCardContract.css';


function CreatePersonalContractCard() {
  // Карточка обслуживает и /contract/:id, и /network/:id. При смене типа обучения адрес
  // меняется, а id нет, и роутер переиспользовал бы компонент со старыми данными.
  // Ключ по адресу заставляет смонтировать карточку заново и перезапросить слушателя.
  const { pathname } = useLocation();

  return (
    <>
      <Header />
      <div className="container_AddStudent">
        <PersonalCardContract key={pathname} />
      </div>
    </>
  );
}

export default CreatePersonalContractCard;
